/* eslint-disable react/require-default-props */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import './style.less';
import SvgComponent from 'shared/components/svgComponent';
import { ApplicationState } from 'store/combineReducers';
import { baseUrlUser } from 'utils/api';
import { Image as AntImage } from 'antd';

interface LogoProps {
  dark?: boolean;
  svg?: boolean;
  collapsed?: boolean;
}

const logoDefault = `/static/images/vivalink-logo.png`;

export default function LogoNew({
  dark,
  svg,
  collapsed,
}: LogoProps): ReactElement {
  const { user } = useSelector((state: ApplicationState) => state.session);
  const { settingInfo } = useSelector(
    (state: ApplicationState) => state.settingInfo,
  );
  const [logoPath, setLogoPath] = useState(logoDefault);

  useEffect(() => {
    if (settingInfo?.theme != null && settingInfo?.theme?.logoImage != null) {
      setLogoPath(settingInfo.theme.logoImage);
    }
  }, [settingInfo]);

  function renderLogo() {
    if (svg) {
      return collapsed ? (
        <SvgComponent
          style={{ marginLeft: 9 }}
          iconName="logoSmall"
          className="logo-source"
        />
      ) : (
        <SvgComponent iconName="logoNew" className="logo-source" />
      );
    }
    return <AntImage width={180} height={30} src={logoPath} preview={false} />;
  }
  return (
    <Link
      to={baseUrlUser(user?.roles[0]?.name)}
      className={`logo-wrapper${svg ? '' : '-new'}${dark ? ' dark' : ''}`}
    >
      {renderLogo()}
    </Link>
  );
}

LogoNew.defaultProps = {
  dark: false,
};
